module.exports = __webpack_public_path__ + "assets/images/mail46195f0d458a9c58aaf4ea5216a9dbf7.svg";